import axios from "axios";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const API = axios.create({
	baseURL: `/api`
});

export function validateAttachment(attachment) {
	return new Promise((resolve, reject) => {
		API.post(`details/attachments/validate`, attachment, {
			headers: {
				"Content-Type":
					"multipart/form-data; charset=utf-8; boundary=" +
					Math.random()
						.toString()
						.substr(2)
			}
		})
			.then(response => {
				resolve(response.data.data);
			})
			.catch(error => {
				reject(error.response.data);
			});
	});
}

export function uploadAttachment(attachment) {
	return new Promise((resolve, reject) => {
		API.post(`details/attachments`, attachment, {
			headers: {
				"Content-Type":
					"multipart/form-data; charset=utf-8; boundary=" +
					Math.random()
						.toString()
						.substr(2)
			}
		})
			.then(response => {
				resolve(response.data.data);
			})
			.catch(error => {
				reject(error.response.data);
			});
	});
}



// WEBPACK FOOTER //
// ./resources/js/api/index.js